export default "__VITE_ASSET__ff59b107__"